import React from 'react';

// Primary / secondary action row used at the bottom of every wizard step.
// Pass `submit` to turn the primary button into a form submit button.
export default function StepActions({
  onNext,
  onCancel,
  submit = false,
  nextLabel = 'Next',
  cancelLabel = 'Cancel',
  loading,
  leading,
  className = 'form-actions mt-3'
}) {
  return (
    <div className={className}>
      {leading}
      {(onNext || submit) && (
        <button
          type={submit ? 'submit' : 'button'}
          className="btn btn-primary"
          onClick={submit ? undefined : onNext}
          disabled={loading}
        >
          {loading ? 'Saving...' : nextLabel}
        </button>
      )}
      {onCancel && (
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          {cancelLabel}
        </button>
      )}
    </div>
  );
}
